import { type ServiceMethod } from '@/application/interfaces/service';

import { type OptinSource } from './get-optin';

export type UnsubscribeOptinsParams = {
  token: string;
  optins: OptinSource[];
};

const unsubscribeOptins: ServiceMethod<void, UnsubscribeOptinsParams> =
  (httpClient) =>
  async ({ token, optins }, options) => {
    const { body } = await httpClient.post<
      void,
      Pick<UnsubscribeOptinsParams, 'optins'>,
      undefined,
      Pick<UnsubscribeOptinsParams, 'token'>
    >('/api/v3/inhabitants/optins/unsubscribe', {
      ...options,
      searchParams: { token },
      body: { optins },
    });

    return body;
  };

export default unsubscribeOptins;
